module.exports = __webpack_public_path__ + "static/assets/8d614abcd1ceaddbf756c6ac7210baa1.png";